import script from "./SubItem.vue?vue&type=script&setup=true&lang=js"
export * from "./SubItem.vue?vue&type=script&setup=true&lang=js"

import "./SubItem.vue?vue&type=style&index=0&id=ac1da0f6&lang=css"

const __exports__ = script;

export default __exports__